import React from 'react'
import { Spacer, Text, View } from 'oio-react'
import RichText from 'src/components/utils/RichText'
import { useOrganization } from 'src/graphql/hooks'

const Home = () => {
   const { organization } = useOrganization()
   const logoUrl = organization.logoDefaultNegative?.file.thumbnailUrlW240

   return (
      <View
         display="flex"
         justifyContent="center"
         alignItems="center"
         height="100vh"
         minHeight="600px"
         backgroundColor="#0e181b">
         <View
            width="100%"
            maxWidth="600px"
            textAlign="center"
            padding="30px">
            <View display="flex" flexFlow="column" alignItems="center" float="left" width="100%">
               <View display="inline-block">
                  <img
                     alt={organization.name}
                     src={logoUrl}
                     height="48px"
                  />
               </View>
               <View
                  display="inline-block"
                  width="1px"
                  height="30px"
                  margin="18px 0px"
                  backgroundColor="rgba(255,255,255,0.2)"
               />
               <Text size="1.5" color="#fff" transform="uppercase" weight="medium" letterSpacing="2px">
                  {organization.tagline}
               </Text>
               <Spacer size="3" />
               <Text size="2.5" lineHeight="130%" color="rgba(255,255,255,0.5)">
                  <RichText html={organization.description} />
               </Text>
               <Spacer size="3" />
            </View>
            <View float="left" width="100%">
               <a href="mailto:hello@mother.co">
                  <Text
                     size="1"
                     color="rgba(176, 166, 142, 0.8)"
                     transform="uppercase"
                     weight="medium">
                     Contact us at:
                     &nbsp;
                     <u>hello@mother.co</u>
                  </Text>
               </a>
            </View>
         </View>
      </View>
   )
}

export default Home
